<template>
  <v-row>
    <!-- <v-carousel>
      <v-carousel-item src="" cover></v-carousel-item>

      <v-carousel-item src="" cover></v-carousel-item>

      <v-carousel-item src="" cover></v-carousel-item>
    </v-carousel> -->
  </v-row>
  <v-row>
    <v-col v-for="(card, i) in visibleCardLists" :key="i" cols="12" md="4" sm="8">
      <custom-card
        :disabled="card.disabled"
        :title="card.title"
        :subTitle="card.subTitle"
        :text="card.text"
        :toPath="card.path"
        :color="card.color"
        :newTab="card.newTab"
        @startButtonClicked="handleCardClick(card)"
      ></custom-card>
    </v-col>
  </v-row>
  <v-row>
    <v-col v-for="(card, i) in bottomCardLists" :key="`bottom-${i}`" cols="12" md="4" sm="8">
      <custom-card
        :disabled="card.disabled"
        :title="card.title"
        :subTitle="card.subTitle"
        :text="card.text"
        :toPath="card.path"
        :color="card.color"
        :newTab="card.newTab"
        @startButtonClicked="handleCardClick(card)"
      ></custom-card>
    </v-col>
  </v-row>
</template>

<script>
import CustomCard from '../components/card/CustomCard.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {CustomCard},
  data() {
    return {
      cardLists: [
      {
        title: "E-DB",
        subTitle: "Exposome Database",
        disabled: false,
        text: 'This function was designed to search the basic "node" and "link" information of the "Exposure-Biology-Disease" network. A total of 20+ databases were curated for linking the exposome to disease. To download the latest, please see: http://www.exposomex.cn/#/download',
        path: "/edb",
        color: "primary",
        moduleName: "edb"
      },{
        title: "E-BIO",
        subTitle: "Biological Link",
        disabled: false,
        text: 'This function was designed to build the network of "Exposure-Biology-Disease" nexus by adopting one-layer or two-layer models using GO, genes, and proteins based on 20+ databases. To download the latest, please see: http://www.exposomex.cn/#/download',
        path: "/ebio",
        color: "primary",
        moduleName: "ebio"
      },{
        title: "E-VIZ",
        subTitle: "Data Visualization",
        disabled: false,
        text: "This function was designed to conduct an exploratory description analysis of the exposome data. Visualization tasks were grouped as category, relationship, distribution, and components",
        path: "/eviz",
        color: "primary",
        moduleName: "eviz"
      },{
        title: "E-META",
        subTitle: "Meta-Analysis",
        disabled: true,
        text: "Automatically extracting study information, population data, chemical exposure, disease outcomes, and risk effects from uploaded literature PDFs based on target chemical and disease lists, and converting them into standardized structured tables.",
        path: "",
        color: "primary",
        moduleName: "emeta"
      },{
        title: "E-STAT",
        subTitle: "Statistical Analysis",
        disabled: true,
        text: "This function was designed to implement statistical analyses, including the three stages of exploratory analysis,  building model, and data interpretation. A total of 10 modules were designed in consideration of the study design, data structure, and analysis aim.",
        path: "/start-stat",
        color: "primary",
        moduleName: "estat"
      },{
        title: "E-MS",
        subTitle: "Mass SpectromeTry",
        disabled: true,
        text: "This function was designed to implement statistical analysis and annotation of non-target analysis (NTA) data for the epidemiological studies with various data structures. Users can use only MS1 or combine MS1 and MS2 information.",
        path: "",
        color: "primary",
        moduleName: "ems"
      },{
        title: "LCAP",
        subTitle: "",
        disabled: false,
        text: "An integrated framework to assess global high-resolution Lung Cancer burden attributable to ambient Air Pollution through latency-aware and biological mechanisms",
        path: "/lcap",
        color: "primary",
        moduleName: "lcap"
      },{
        title: "TREAT",
        subTitle: "",
        disabled: false,
        text: "Analyzing the temporal and regional profile of human exposure chemicals using the Toxicological Risk Evaluation & Adaptive Tracking (TREAT) strategy",
        path: "/treat",
        color: "primary",
        moduleName: "treat"
      },{
        title: "WBE",
        subTitle: "Wastewater Exposome",
        disabled: true,
        text: "Ranking the human health risk of various chemicals though their concentration information of the input water of wastewater sample, which can be obtained by extracting the input papers or users uploaded information.",
        path: "/ewwe",
        color: "primary",
        moduleName: "ewwe"
      },{
        title: "HExpPred",
        subTitle: "",
        hidden: true,
        disabled: true,
        text: "This function was designed to use AI models to predict blood concentrations across the human chemical exposome and prioritize chemicals of potential health concern.",
        path: "",
        color: "primary",
        moduleName: "hexppred"
      }],
      bottomCardLists: [
      {
        title: "EPIC",
        subTitle: "",
        disabled: false,
        text: "An integrated framework to map China's industrial emission exposome and pinpoint disease-specific pollutant–source targets.",
        path: "/epic",
        color: "primary",
        moduleName: "epic"
      },{
        title: "UMR",
        subTitle: "",
        disabled: false,
        text: "An integrated framework to assess global Urbanization reshaped toxic Metal-associated disease Risk potential",
        path: "/umr",
        color: "primary",
        moduleName: "umr"
      },      {
        title: "WPN",
        subTitle: "",
        disabled: false,
        text: "A wastewater-based framework for prioritizing neurotoxic chemical mixtures across European cities.",
        path: "/wpn",
        color: "primary",
        moduleName: "wpn"
      }],
      isLoading: false
    };
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    visibleCardLists() {
      return this.cardLists.filter(card => !card.hidden);
    }
  },
  methods: {
    ...mapActions(['createSession']),
    
    async handleCardClick(card) {
      // 检查是否是 E-BIO 或 E-DB 模块并且已启用
      if ((card.title === 'E-BIO' || card.title === 'E-DB') && !card.disabled) {
        // 首先检查用户是否已登录
        if (!this.isLoggedIn) {
          console.log('用户未登录，跳转到登录页面');
          this.$router.push('/login');
          return;
        }

        try {
          this.isLoading = true;
          console.log(`点击 ${card.title} 卡片，开始创建会话...`);

          // 调用 Vuex action 创建会话
          const sessionData = await this.createSession({
            module_name: card.moduleName
          });

          console.log('会话创建成功:', sessionData);
          console.log('Session UUID:', sessionData.session);

          // 会话创建成功后跳转到对应页面，并在 URL 中添加 session 参数
          const modulePath = `${card.path}?session=${sessionData.session}`;
          this.$router.push(modulePath);

        } catch (error) {
          console.error('创建会话失败:', error);
          // 处理错误，可以显示错误提示
          if (error.message === '用户未登录') {
            // 如果用户未登录，跳转到登录页面
            this.$router.push('/login');
          } else {
            // 其他错误，显示错误消息
            alert('创建会话失败：' + error.message);
          }
        } finally {
          this.isLoading = false;
        }
      }
      // 对于其他模块，保持原有的跳转逻辑
      // CustomCard 组件中的 :to="toPath" 会自动处理路由跳转
    }
  }
};
</script>

<style scoped>

</style>
